
<div class="api-customer-view">
  <page-header :title="title">
    <template #actions>
      <icon-button
        icon="arrow_back"
        tooltip="Back to API Customers"
        @click="$router.push('/api-customers')"
      />
    </template>
  </page-header>

  <section v-if="loaded && customer">
    <p class="credential">
      {{ customer.credentialId }}
    </p>

    <p class="note">
      Daily call counts for the last 14 days, Central Time. Today includes calls so far.
    </p>

    <div class="table-container">
      <table class="usage-table">
        <thead>
          <tr>
            <th>Date</th>
            <th right>
              Calls
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="day in customer.days" :key="day.date">
            <td>
              {{ day.label }}
              <span v-if="day.partial" class="partial">so far</span>
            </td>
            <td right>
              {{ $filters.number(day.calls) }}
            </td>
          </tr>

          <tr class="total">
            <td>Total</td>
            <td right>
              {{ $filters.number(customer.total) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <empty-state
    v-else-if="loaded"
    icon="vpn_key"
    title="This API customer could not be loaded"
  />

  <spinner v-else />
</div>
